import React from 'react';
import styles from './PageCenterLayout.module.css';

interface PageCenterLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function PageCenterLayout({ children, className = '' }: PageCenterLayoutProps) {
  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}
